<button mat-flat-button
        type="button"
        style="padding:0"
        [disabled]="disabled"
        (click)="click()">
    <img *ngIf="!disabled" src="{{testo}}"  border="0" width="{{width}}" height="{{height}}" />
</button>
